export default __webpack_public_path__ + "img/a59778bed791deb120ba5ce96da9ce90.svg";